<template lang="html">
  <div class="dashboard">
    <PageTitle title="Dashboard" />
    <Polls />
  </div>
</template>

<script>
import PageTitle from "@/components/header/PageTitle.vue";
import Polls from "@/components/dashboard/Polls.vue";
export default {
  components: {
    PageTitle,
    Polls
  }
};
</script>

<style lang="css"></style>
